import axios from "axios";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const WA_NUMBER = "628138319664";
export const WA_DISPLAY = "+62 813-8319-664";

const api = axios.create({ baseURL: API_BASE, withCredentials: true });

export const formatIDR = (n) => "Rp " + Number(n || 0).toLocaleString("id-ID");

export const normalizePhone = (phone) => {
    let num = String(phone || "").replace(/\D/g, "");
    if (num.startsWith("0")) num = "62" + num.slice(1);
    return num;
};

export const formatPhone = (phone) => {
    if (!phone) return "";
    const num = normalizePhone(phone);
    return num.startsWith("62") ? "+" + num : num;
};

export const waOrderLink = (title, price, phone) => {
    const num = normalizePhone(phone) || WA_NUMBER;
    return `https://wa.me/${num}?text=${encodeURIComponent(
        `Halo Acture.id! Saya mau order & konsultasi produk "${title}"${price ? ` (${formatIDR(price)})` : ""}. Apakah masih tersedia?`
    )}`;
};

export const waGeneralLink = () =>
    `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
        "Halo Acture.id! Saya mau konsultasi soal produk daur ulang nih."
    )}`;

export const waLink = (text) =>
    `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Ada yang salah, coba lagi ya.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(", ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default api;
